function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_20046756_85957)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.5013 15.3333L8.7093 15.8547C8.60664 15.9473 8.45597 16 8.2993 16H7.7033C7.54664 16 7.39597 15.9473 7.29264 15.8547L6.5013 15.3333H9.5013ZM9.5293 14C9.7133 14 9.86264 14.1493 9.86264 14.3333C9.86264 14.518 9.7133 14.6667 9.5293 14.6667H6.49064C6.30664 14.6667 6.1573 14.518 6.1573 14.3333C6.1573 14.1493 6.30664 14 6.49064 14H9.5293ZM9.85864 13.3333H6.14397C6.14397 10.7007 4.0013 9.56067 4.0013 7.18133C4.0013 4.69933 5.99997 3.33333 7.9993 3.33333C9.99997 3.33333 12.0013 4.70133 12.0013 7.18133C12.0013 9.56067 9.85864 10.664 9.85864 13.3333ZM13.1606 8.514L14.96 9.33L14.4086 10.5447L12.678 9.76C12.8786 9.36 13.0446 8.95 13.1606 8.514ZM2.84264 8.514C2.95797 8.95667 3.1193 9.35467 3.32197 9.76067L1.59397 10.5447L1.04264 9.33L2.84264 8.514ZM13.2093 6H15.3346V7.33333H13.3326C13.3466 6.88667 13.306 6.43667 13.2093 6ZM2.79264 6C2.6973 6.436 2.6573 6.884 2.66997 7.33V7.33333H0.667969V6H2.79264ZM12.03 3.71467L13.6866 2.53933L14.4586 3.62667L12.7886 4.81133C12.594 4.42333 12.342 4.05667 12.03 3.71467ZM3.97197 3.714C3.6653 4.04933 3.41397 4.414 3.2133 4.81067L1.54464 3.62667L2.31597 2.53933L3.97197 3.714ZM9.88464 2.31933L10.7693 0.526L11.9646 1.116L11.08 2.90933C10.7086 2.66467 10.306 2.46667 9.88464 2.31933ZM6.1173 2.318C5.69664 2.46467 5.2933 2.662 4.9213 2.90733L4.0373 1.116L5.2333 0.526L6.1173 2.318ZM8.66797 2.04067C8.22264 1.98867 7.7953 1.986 7.33464 2.03867V0H8.66797V2.04067Z",
  fill: "white"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_20046756_85957"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.dec880081eb37913eaaa399d839b8049.svg";
export { ForwardRef as ReactComponent };